import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { GraduationCap, Users, Code, Cloud } from 'lucide-react';

const ServicesOverview = () => {
  const services = [
    {icon: GraduationCap, title: 'Corporate Training & Placement', description: 'Industry-aligned programs for students, professionals & enterprises', gradient: 'from-[#00E5FF] to-[#1DE9B6]', link: '/corporate-training'},
    {icon: Users, title: 'Recruitment & Talent Solutions', description: 'Job-ready IT & Non-IT talent for organizations', gradient: 'from-[#1DE9B6] to-[#38BDF8]', link: '/recruitment'},
    {icon: Code, title: 'Software Development', description: 'Web, mobile, cloud & custom enterprise applications', gradient: 'from-[#38BDF8] to-[#00E5FF]', link: '/software-development'},
    {icon: Cloud, title: 'IT Services & Consulting', description: 'Cloud, DevOps, AI, data & digital transformation', gradient: 'from-[#00E5FF] to-[#38BDF8]', link: '/it-services'},
  ];

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0F1A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-['Space_Grotesk']">Our <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Services</span></h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mx-auto mb-4"></div>
          <p className="text-xl text-[#9CA3AF] max-w-3xl mx-auto">Comprehensive solutions to power your digital transformation journey</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            const isLink = service.link.startsWith('/');
            return isLink ? (
              <Link key={index} to={service.link}>
                <Card className="group hover:shadow-2xl hover:shadow-[#00E5FF]/20 transition-all duration-500 hover:-translate-y-3 bg-[#111827] border-2 border-[#00E5FF]/20 hover:border-[#00E5FF]/60 cursor-pointer overflow-hidden relative h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#00E5FF]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <CardHeader className="relative z-10">
                    <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-4 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-[#00E5FF]/50 transition-all duration-300`}>
                      <Icon className="w-7 h-7 text-[#0B0F1A]" />
                    </div>
                    <CardTitle className="text-xl font-bold text-white group-hover:text-[#00E5FF] transition-colors font-['Space_Grotesk']">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10">
                    <p className="text-[#9CA3AF] leading-relaxed mb-4">{service.description}</p>
                    <span className="text-[#00E5FF] text-sm font-medium group-hover:underline">Learn More →</span>
                  </CardContent>
                </Card>
              </Link>
            ) : (
              <a key={index} href={service.link}>
                <Card className="group hover:shadow-2xl hover:shadow-[#00E5FF]/20 transition-all duration-500 hover:-translate-y-3 bg-[#111827] border-2 border-[#00E5FF]/20 hover:border-[#00E5FF]/60 cursor-pointer overflow-hidden relative h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#00E5FF]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <CardHeader className="relative z-10">
                    <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-4 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-[#00E5FF]/50 transition-all duration-300`}>
                      <Icon className="w-7 h-7 text-[#0B0F1A]" />
                    </div>
                    <CardTitle className="text-xl font-bold text-white group-hover:text-[#00E5FF] transition-colors font-['Space_Grotesk']">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10">
                    <p className="text-[#9CA3AF] leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
